import { apiFetch } from "./apiClient";

export async function getAllBoxes() {
    const response = await apiFetch("/box");
    if (!response.ok) {
        throw new Error("Failed to fetch boxes");
    }
    return await response.json();
}

export async function getBoxById(id) {
    const response = await apiFetch(`/box/${id}`);
    if (!response.ok) {
        throw new Error(`Failed to fetch box with id ${id}`);
    }
    return await response.json();
}
